import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { UserAvatar } from "@/features/user-avatar";
import { formatDate } from "@/lib/date-tools";
import { MessageCircleMore } from "lucide-react";
import { useMemo } from "react";
// import { useEffect } from "react";
// import { useSignals } from "@preact/signals-react/runtime";
// import { useSignal } from "@preact/signals-react";

export function ChatButton({
  asButton = true,
  chat,
  variant = "outline",
  className,
  onClick,
  hasNewMessage = false,
  // children,
}: {
  asButton?: boolean;
  chat: any;
  variant?:
    | "default"
    | "secondary"
    | "outline"
    | "ghost"
    | "destructive"
    | null
    | undefined;
  className?: string;
  onClick?: () => void;
  hasNewMessage?: boolean;
  // children?: React.ReactNode;
}) {
  const latestMessage = useMemo(() => {
    if (!chat.latestMessage) return null;

    return {
      ...chat.latestMessage,
      sender: chat.userMap[chat.latestMessage.sender._id],
    };
  }, [chat]);
  const Component = asButton ? Button : "div";

  return (
    <Component
      variant={asButton ? variant : undefined}
      className={cn(
        "w-full justify-between items-center px-2 py-6 relative",
        !asButton && "flex py-2", // div일 때 추가 스타일
        className,
      )}
      onClick={onClick}
    >
      {/* 새 메시지 알림 표시 */}
      {hasNewMessage && (
        <div className="absolute top-2 right-2 w-2 h-2 bg-red-500 rounded-full" />
      )}
      <div className="flex flex-1 items-center">
        {chat.friend ? (
          <>
            <UserAvatar picture={chat.friend.picture} />
            <div className="grid text-left text-sm leading-tight pl-2">
              <span className="truncate font-semibold">{chat.friend.name}</span>
              <span className="truncate text-xs">
                {latestMessage ? latestMessage.content : "..."}
              </span>
            </div>
          </>
        ) : (
          <>
            <MessageCircleMore className="h-8 w-8 min-w-8 min-h-8" />
            <div className="grid text-left text-sm leading-tight pl-2">
              <span className="truncate font-semibold">{chat.chatName}</span>
              <span className="truncate text-xs">
                {latestMessage
                  ? latestMessage.sender.name + ": " + latestMessage.content
                  : "..."}
              </span>
            </div>
          </>
        )}
      </div>
      <div className="truncate text-xs">
        {latestMessage && formatDate(latestMessage.updatedAt, "MM-DD")}
      </div>
    </Component>
  );
}
